import { ptBR } from "../ptBR";
import { enUS } from "../enUS";

export const countries = [
    {label: 'Português (Brasil)', lang: ptBR },
    {label: 'Inglês', lang: enUS }
];